import React, { Fragment, useState } from "react";
import Parser from "application/components/parser";
import SquareFilled from "assets/img/square-filled.png";
import SquareNotFilled from "assets/img/square-not-filled.png";

const CheckBoxInput = (props) => {
  const { name, path, register } = props;
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Fragment>
      <div className="field-creator__checkbox-container-with-error">
        <div className="field-creator__checkbox-container">
          <label className="field-creator__checkbox-row">
            <input
              name={path}
              type="checkbox"
              ref={register}
              onChange={(v) => {
                setIsChecked(!isChecked);
              }}
            />
            <img src={isChecked ? SquareFilled : SquareNotFilled} alt="check" />
            <div style={{ fontWeight: "500" }}>
              <Parser text={name} />
            </div>
          </label>
        </div>
      </div>
    </Fragment>
  );
};

export default CheckBoxInput;
